import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { COMPANIES, Wordmark } from '@/components/art/wordmark'

interface LogoRowProps {
    hidden?: boolean
}

const LogoRow: FC<LogoRowProps> = ({ hidden = false }): ReactNode => {
    return (
        <ul aria-hidden={hidden || undefined} className='ticker-copy flex shrink-0 items-center'>
            {COMPANIES.map(name => (
                <li key={name} className='ticker-item mr-16 flex h-10 shrink-0 items-center'>
                    <Wordmark name={name} className='text-[18px] text-ink/90' />
                </li>
            ))}
        </ul>
    )
}

interface LogoTickerProps {
    label: string
    className?: string
}

/** An endless, slow ticker of wordmarks in a single warm brown. Hovering pauses it and brings one logo forward. */
export const LogoTicker: FC<LogoTickerProps> = ({ label, className }): ReactNode => {
    return (
        <div className={cn('relative w-full max-w-[1080px]', className)}>
            <p className='text-center text-[14px] font-medium text-ink/80'>
                {label}
            </p>

            <div className='ticker mt-4 overflow-hidden'>
                <div className='ticker-track flex w-max'>
                    <LogoRow />
                    <LogoRow hidden />
                </div>
            </div>
        </div>
    )
}
